// src/components/PostCard/index.jsx
import React from 'react';
import { Card, Tag, Typography, Space, Flex } from 'antd';
import { CalendarOutlined, PushpinOutlined, UserOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import './index.css';

const { Title, Paragraph, Text } = Typography;

const PostCard = ({ post }) => {
    return (
        <Card
            hoverable
            className="post-card"
            bodyStyle={{ padding: 24 }}
        >
            <Flex vertical gap={12}>
                <Link to={`/post/${post.id}`} className="post-card-title-link">
                    <Title level={4} className="post-card-title">
                        {post.title}
                    </Title>
                </Link>
                <Paragraph type="secondary" ellipsis={{ rows: 2 }} className="post-card-summary">
                    {post.summary}
                </Paragraph>
                <Space size={[0, 8]} wrap className="post-card-tags">
                    <Text type="secondary"><PushpinOutlined /> 标签:</Text>
                    {post.tags.map(tag => (
                        <Tag key={tag} color="blue">{tag}</Tag>
                    ))}
                </Space>
                <Flex justify="space-between" align="center" className="post-card-meta">
                    <Text type="secondary">
                        <Space>
                            <UserOutlined /> {post.author}
                            <CalendarOutlined /> {new Date(post.date).toLocaleDateString()}
                        </Space>
                    </Text>
                    <Link to={`/post/${post.id}`}>
                        阅读全文 &gt;
                    </Link>
                </Flex>
            </Flex>
        </Card>
    );
};

export default PostCard;

